var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.componentName,{tag:"component",attrs:{"field":_vm.field,"index":_vm.index},on:{"update":_setup.handleUpdate}})
}
var staticRenderFns = []

export { render, staticRenderFns }